import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin';
import { Box, Typography } from '@mui/material';
import CustomCloseButton from '@/components/global/buttons/CustomCloseButton.jsx';
import { EditForm } from '@/components/newDevice/forms/EditForm.jsx';

export const EditDrawer = ({ handleClose, elementId }) => {
    const translate = useTranslate();
    return (
        <Box>
            <Box className='popup-wrapper popup-wrapper-top border-bottom'>
                <Box className='popup-box popup-box--header'>
                    <Typography variant='h4'>{translate('resources.device.labels.editNewDeviceTitle')}</Typography>
                    <Box>
                        <CustomCloseButton onClose={handleClose} />
                    </Box>
                </Box>
            </Box>
            {elementId && <EditForm id={elementId} onSave={handleClose} onClose={handleClose} />}
        </Box>
    );
};

EditDrawer.propTypes = {
    elementId: PropTypes.string,
    handleClose: PropTypes.func.isRequired,
};
